<template lang="pug">
  v-row.px-2.ma-0
    .margin-bottom-0.col-12
      skeleton-card(v-if="isLoading")
      v-card.v-card.gridFull.ma-0.borderDelivery.p-4(v-if="!isLoading")
        .d-flex.block-title.titleGrid.mb-4
          p.mb-0.title-card.text-lg.font-semibold
            | {{ $gettext('Orders.') }} 
            span.ml-1.tDelivery {{ $gettext('Assessment') }}
          .block-help.ml-auto
            v-tooltip(right, color="#000", open-on-click="true", max-width="450", nudge-bottom="40", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
              template(v-slot:activator="{ on, attrs }")
                img(:src="imgCommons.help", v-bind="attrs", v-on="on")
              span {{ $gettext('Analysis of the satisfaction of orders received in the selected period, compared to the same previous period as well as the trend of the same') }}
        .table-scroll-wrapper 
          v-simple-table.table-responsive.text-sm(dense, id="tableOrders")
            thead
              tr
                th.sticky-col
                th {{ isAdverbia ? $gettext('Number of reviews') : $gettext('Number of orders') }}
                th {{$gettext('Orders with rating')}}
                th {{$gettext('Orders with comments')}}
                th {{$gettext('Orders with positive feedback')}}
                th {{$gettext('Orders with negative feedback')}}
                th {{$gettext('Score / Satisfaction')}}
            tbody
              tr(v-for="(item, index) in dataSummaryDelivery[0]['delivery_rating']", :key="index", :class="{ hide: !deliverySitesStatus[item.code] }")
                td.sticky-col
                  v-row(no-gutters, align="center")
                    v-col(cols="auto")
                      v-img.mr-2(:src="item.logo", alt="logo", height="24", width="24", contain)
                    v-col.d-flex.flex-column.justify-center
                      span.text-caption.text--darken-3.mb-1 {{ item.name }}
                      small.text-caption.ma-0.pa-0.text-small {{ $gettext('Previous period') }}
                td
                  .value-cell(v-if="item.n_orders")
                    .top
                      span.main-value {{ item.n_orders || 0 }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-if="item.tend_n_orders!=null", v-bind="attrs", v-on="on", :class="getArrow(item.n_orders, item.tend_n_orders)")
                        span(v-if="item.tend_n_orders!=null") {{item.tend_n_orders | formatNumber }}
                    .bottom
                      small.sub-value {{ item.previous_period_n_orders || 0 }}
                  div(v-else) -
                td
                  .value-cell(v-if="item.review_count ")
                    .top
                      span.main-value {{ item.review_count}}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-if="item.tend_review_count!=null", v-bind="attrs", v-on="on", :class="getArrow(item.review_count, item.tend_review_count)")
                        span(v-if="item.tend_review_count!=null") {{item.tend_review_count | formatNumber }}
                    .bottom
                      small.sub-value {{ item.previous_period_review_count }}
                  div(v-else) -
                td
                  .value-cell
                    .top
                      span.main-value {{ item.text_count }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-if="item.tend_text_count!=null", v-bind="attrs", v-on="on", :class="getArrow(item.text_count, item.tend_text_count)")
                        span(v-if="item.tend_text_count!=null") {{item.tend_text_count | formatNumber }}
                    .bottom
                      small.sub-value {{ item.previous_period_text_count }}
                td
                  .value-cell
                    .top
                      span.main-value {{ item.n_positive_reviews || 0 }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-if="item.tend_review_count_positive!=null", v-bind="attrs", v-on="on", :class="getArrow(item.n_positive_reviews, item.tend_review_count_positive)")
                        span(v-if="item.tend_review_count_positive!=null") {{item.tend_review_count_positive | formatNumber }}
                    .bottom
                      small.sub-value {{ item.previous_period_n_positive_reviews || 0 }}
                td
                  .value-cell
                    .top
                      span.main-value
                        | {{ item.n_negative_reviews || 0 }} 
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-if="item.tend_review_count_negative!=null", v-bind="attrs", v-on="on", :class="getArrow(item.n_negative_reviews, item.tend_review_count_negative)")
                        span(v-if="item.tend_review_count_negative!=null") {{item.tend_review_count_negative | formatNumber }}
                  .bottom
                    small.sub-value {{ item.previous_period_n_negative_reviews || 0 }}
                td
                  div(v-if="item.site_rating && item.code == 'JUS'")
                    v-row.no-gutters.d-flex.align-center.justify-space-between(style="width:100%")
                      div.d-flex.col-9.justify-center
                        just-eat-rating(:smaller="false", :ranking="item.site_rating")
                      div.d-flex.col3.justify-center
                        v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                            template(v-slot:activator="{ on, attrs }")
                              span.arrow(v-if="item.tend_review_site_rating", v-bind="attrs", v-on="on", :class="getArrow(item.site_rating, item.tend_review_site_rating)")
                    v-row.no-gutters.d-flex.align-center.justify-space-between(style="width:100%")
                      div.d-flex.col-9.justify-center
                        small.sub-value {{ item.previous_period_site_rating }}
                  div(v-else-if="item.code === 'GLV'")
                    v-row.no-gutters.d-flex.align-center.justify-space-between(style="width:100%")
                      div.d-flex.col-9.justify-center
                        v-row.no-gutters.justify-center.items-center.no-bottom
                          div.d-flex.justify-center.items-center.mr-1
                            img.mr-0(:src="img.imgRatingGlovoRegular" style="width:15px;height:15px")
                            span.text-12 {{item.review_count_positive}}
                          div.d-flex.justify-center.items-center
                            img.mr-0(:src="img.imgRatingBad" style="width:15px;height:15px")
                            span.text-12 {{item.review_count_negative}}
                      div.d-flex.col-3.justify-start
                        span.arrow(v-if="item.tend_review_count_negative!=null", v-bind="attrs", v-on="on", :class="getArrow(item.review_count_negative, item.tend_review_count_negative)")
                    v-row.no-gutters.d-flex.align-center.justify-space-between(style="width:100%")
                      div.d-flex.col-9.justify-center
                        v-row.no-gutters.justify-center.items-center.no-bottom
                          div.d-flex.justify-center.items-center.mr-1
                            span.text-10 {{item.previous_period_count_positive}}
                          div.d-flex.justify-center.items-center
                            span.text-10 {{item.previous_period_count_negative}}
                  div(v-else-if="item.code === 'UBE'")
                    v-row.no-gutters.d-flex.align-center.justify-space-between(style="width:100%")
                      div.d-flex.col-9.justify-center
                        img(:src="img.imgStar")
                        | {{ item.site_rating | formatNumber }}
                      div.d-flex.col3.justify-center
                        v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                          template(v-slot:activator="{ on, attrs }")
                            span.arrow(v-if="item.tend_review_site_rating!=null", v-bind="attrs", v-on="on", :class="getArrow(item.site_rating, item.tend_review_site_rating)")
                          span(v-if="item.tend_review_site_rating!=null") {{item.tend_review_site_rating | formatNumber }}
                    v-row.no-gutters.d-flex.align-center.justify-space-between(style="width:100%")
                      div.d-flex.col-9.justify-center
                        small.sub-value {{ item.previous_period_site_rating | formatNumber }}
    .margin-bottom-0.col-12
      skeleton-card(v-if="isLoading")
      v-card.v-card.gridFull.ma-0.borderDelivery.p-4(v-if="!isLoading")
        .d-flex.block-title.titleGrid.mb-4
          .block-title.titleGrid.mb-4
            p.mb-0.title-card.text-lg.font-semibold
              | {{$gettext('Orders.')}} 
              span.ml-1.tDelivery {{$gettext('Service')}}
          .block-help.ml-auto
            v-tooltip(right, color="#000", open-on-click="true", max-width="450", nudge-bottom="40", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
              template(v-slot:activator="{ on, attrs }")
                img(:src="imgCommons.help", v-bind="attrs", v-on="on")
              span {{ $gettext('Analysis of the orders received in the selected period, compared to the same previous period as well as the trend of the same') }}
        .table-scroll-wrapper
          v-simple-table.table-responsive.text-sm(dense, id="tableOrders")
            thead
              tr
                th.sticky-col
                th {{$gettext('Wrong Orders')}}
                th {{$gettext('Cancelled Orders')}}
                th {{$gettext('Local Cancellation')}}
                th {{$gettext('Web Cancellation')}}
                th {{$gettext('Waiting time (m.)')}}
                th {{$gettext('New users')}}
            tbody
              tr(v-for="(item, index) in dataSummaryDelivery[0]['delivery_rating']", :key="index", :class="{ hide: !deliverySitesStatus[item.code] }")
                td.sticky-col
                  v-row(no-gutters, align="center")
                    v-col(cols="auto")
                      v-img.mr-2(:src="item.logo", alt="logo", height="24", width="24", contain)
                    v-col.d-flex.flex-column.justify-center
                      span.text-caption.text--darken-3.mb-1 {{ item.name }}
                      small.text-caption.ma-0.pa-0.text-small {{ $gettext('Previous period') }}
                td
                  .value-cell(v-if="item.wrong_order")
                    .top
                      span.main-value {{ item.wrong_order || 0 }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-bind="attrs", v-on="on", :class="getArrow(item.wrong_order, item.tend_wrong_order)")
                        span {{ item.tend_wrong_order || "-" }}
                    .bottom
                      small.sub-value {{ item.previous_period_wrong_order }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-bind="attrs", v-on="on", :class="getArrow(item.previous_period_wrong_order, item.previous_period_tend_wrong_order)")
                        span {{ item.previous_period_tend_wrong_order || "-" }}
                  div(v-else) -
                td
                  .value-cell(v-if="item.n_cancelled")
                    .top
                      span.main-value {{ item.n_cancelled || 0 }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-bind="attrs", v-on="on", :class="getArrow(item.n_cancelled, item.tend_n_cancelled)")
                        span {{ item.tend_n_cancelled || "-" }}
                    .bottom
                      small.sub-value
                        | {{ item.previous_period_n_cancelled }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-bind="attrs", v-on="on", :class="getArrow(item.previous_period_n_cancelled, item.previous_period_tend_n_cancelled)")
                        span {{ item.previous_period_tend_n_cancelled || "-" }}
                  div(v-else) -
                td
                  .value-cell(v-if="item.n_cancelled_by_local")
                    .top
                      span.main-value {{ item.n_cancelled_by_local }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-bind="attrs", v-on="on", :class="getArrow(item.n_cancelled_by_local, item.tend_n_cancelled_by_local)")
                        span {{ item.tend_n_cancelled_by_local || "-" }}
                    .bottom
                      small.sub-value {{ item.previous_period_n_cancelled_by_local }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-bind="attrs", v-on="on", :class="getArrow(item.previous_period_n_cancelled_by_local, item.previous_period_tend_n_cancelled_by_local)")
                        span {{ item.previous_period_tend_n_cancelled_by_local || "-" }}
                  div(v-else) -
                td
                  .value-cell(v-if="item.n_cancelled_by_web")
                    .top
                      span.main-value {{ item.n_cancelled_by_web }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-bind="attrs", v-on="on", :class="getArrow(item.n_cancelled_by_web, 90)")
                        span -
                    .bottom
                      small.sub-value {{ item.previous_period_n_cancelled_by_web }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-bind="attrs", v-on="on", :class="getArrow(item.previous_period_n_cancelled_by_web, item.previous_period_tend_n_cancelled_by_web)")
                        span {{ item.previous_period_tend_n_cancelled_by_web || "-" }}

                  div(v-else) -
                td
                  .value-cell(v-if="item.wait_time")
                    .top
                      span.main-value {{ item.wait_time }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-bind="attrs", v-on="on", :class="getArrow(item.wait_time, item.tend_wait_time)")
                        span {{ item.tend_wait_time || "-" }}
                    .bottom(v-if="item.previous_period_wait_time")
                      small.sub-value {{ item.previous_period_wait_time }}
                      v-tooltip(right, color="#222226", open-on-click, max-width="450", nudge-bottom="0", nudge-right="10", content-class="tooltip-help tooltip-help-rigth")
                        template(v-slot:activator="{ on, attrs }")
                          span.arrow(v-bind="attrs", v-on="on", :class="getArrow(item.previous_period_wait_time, item.previous_period_tend_wait_time)")
                        span {{ item.previous_period_tend_wait_time || "-" }}
                  div(v-else) -
                td
                  .rating-num
                    div(v-if="item.new_users")
                      | {{ item.new_users }} 
                      div(v-if="item.previous_period_new_users")
                        small
                          | {{ item.previous_period_new_users }}
                    div(v-else) -

    #boxBarEvolutionOrders.margin-bottom-0.col-12
      skeleton-card(v-if="isLoading")
      v-card.gridFull.ma-0.borderDelivery(v-if="!isLoading")
        .d-flex.headTitleGrid
          .block-title.titleGrid {{ $gettext('Annual Evolution. Average number of orders vs. ratings') }}
          .ml-auto.nav
            button.mr-5(@mousedown="setEvolutionOfAverage('MED', 'yearly')", :class="{ active: activeMenu === 'MED' }") {{ $gettext('Media') }}
            button.mr-5(@mousedown="setEvolutionOfAverage('JUS', 'yearly')", :class="{ active: activeMenu === 'JUS' }")
              img.mr-1(:src="img.imgJustEat")
              span.font-weight-medium {{ $gettext('Just Eat') }}
            button.mr-5(@mousedown="setEvolutionOfAverage('GLV', 'yearly')", :class="{ active: activeMenu === 'GLV' }")
              img.mr-1(:src="img.imgGlovo")
              span.font-weight-medium {{ $gettext('Glovo') }}
            button.mr-5(@mousedown="setEvolutionOfAverage('UBE', 'yearly')", :class="{ active: activeMenu === 'UBE' }")
              img.mr-1(:src="img.imgUberEats")
              span.font-weight-medium {{ $gettext('Uber Eats') }}
        EvolutionOrdersChart(:chartData="chartData", label="media", :scaleLeft="maximumRatingYear", :scaleRight="maximumSaleYear")

    #boxBarEvolutionOrders.margin-bottom-0.col-12
      skeleton-card(v-if="isLoading")
      v-card.gridFull.ma-0.borderDelivery(v-if="!isLoading")
        .d-flex.headTitleGrid
          .block-title.titleGrid Evolutivo Semanal. Media Nº de pedidos vs. valoraciones
          .ml-auto.nav
            button.mr-5(@mousedown="setEvolutionOfAverage('MED', 'weekly')", :class="{ active: activeMenuWeekly === 'MED' }") {{ $gettext('Media') }}
            button.mr-5(@mousedown="setEvolutionOfAverage('JUS', 'weekly')", :class="{ active: activeMenuWeekly === 'JUS' }")
              img.mr-1(:src="img.imgJustEat")
              span.font-weight-medium {{ $gettext('Just Eat') }}
            button.mr-5(@mousedown="setEvolutionOfAverage('GLV', 'weekly')", :class="{ active: activeMenuWeekly === 'GLV' }")
              img.mr-1(:src="img.imgGlovo")
              span.font-weight-medium {{ $gettext('Glovo') }}
            button.mr-5(@mousedown="setEvolutionOfAverage('UBE', 'weekly')", :class="{ active: activeMenuWeekly === 'UBE' }")
              img.mr-1(:src="img.imgUberEats")
              span.font-weight-medium {{ $gettext('Uber Eats') }}
        div(v-if="dataEvolutionLastYearDelivery")
          EvolutionOrdersChart(:chartData="chartDataWeekly", label="media", :scaleLeft="maximumRatingWeekly", :scaleRight="maximumSaleWeekly")
        div.d-flex.align-center.justify-center.py-16(v-else)
          span.font-weight-medium {{ $gettext('No data available') }}

    #boxChartError.col-12
      skeleton-card(v-if="isLoading")
      v-card.v-card.gridFull.ma-0.borderDelivery.p-4(v-if="!isLoading")
        .block-title.titleGrid.mb-4
          p.mb-0.title-card.text-lg.font-semibold
            | {{ $gettext('Errors.') }} 
            span.ml-1.tDelivery
        div.d-flex.align-center.flex-row.justify-center
          div.d-flex.align-center.flex-column
            legend-data( 
              :legend-title="$gettext('Number of orders')" 
              color="#89c445"
            )
            span.text-12 {{ totalOrders }}
          div.d-flex.align-center.flex-column
            legend-data(
              legend-title="Nº de pedidos con error"
              color="#d61a23"
            )
            span.text-12 {{ totalErrors }}
        .chart-wrapper
          .chart-item
            DoughnutChartError(
              :chart-data="doughnutData"
              :centerText="totalErrorsPercentage"
              title="Motivos de error"
            )
          .chart-item
            h3 {{ $gettext('% of error') }}
            LineChartError(:chart-data="lineData")

    #boxChartError.col-12
      skeleton-card(v-if="isLoading")
      v-card.v-card.gridFull.ma-0.borderDelivery.p-4(v-if="!isLoading")
        .block-title.titleGrid.mb-4
          p.mb-0.title-card.text-lg.font-semibold
            | {{ $gettext('Cancellations.') }} 
            span.ml-1.tDelivery
        div.d-flex.align-center.flex-row.justify-center
          div.d-flex.align-center.flex-column
            legend-data( 
              :legend-title="$gettext('Number of orders')" 
              color="#89c445"
            )
            span.text-12 {{ totalOrders }}
          div.d-flex.align-center.flex-column
            legend-data(
              legend-title="Nº de pedidos con error"
              color="#d61a23"
            )
            span.text-12 {{ totalCancel }}
        .chart-wrapper
          .chart-item
            DoughnutChartError(:chart-data="doughnutDataCancelled", :centerText="totalCancelledPercentage", title="Tipo de cancelaciones")
          .chart-item
            h3 {{ $gettext('% of cancellations') }}
            LineChartError(:chart-data="lineCancel")
</template>




<script>
import SkeletonCard from '@/components/common/skeletonCard.vue'
import SrvNetWork from '@/services/delivery.js'
import justEatRating from '@/components/common/justEatRating.vue'
import commonMixins from '@/mixins/common.js'
import brandMixin from '@/mixins/brand.js'
import EvolutionOrdersChart from '@/components/charts/EvolutionOrdersChart.vue'
import DoughnutChartError from  '@/components/charts/DoughnutChartError.vue'
import LineChartError from '@/components/charts/LineChartError.vue'
import LegendData from '@/components/gastropricing/LegendData.vue';

export default {
  name: 'RequestedData',
  components: { justEatRating, EvolutionOrdersChart, DoughnutChartError, LineChartError, SkeletonCard, LegendData },
  mixins: [commonMixins, brandMixin],

  data() {
    return {
    currentEvolutionOfAverage: 'MED',
    weeklyCurrentEvolutionOfAverage: 'MED',
    dateRanges: {},
    deliverySitesStatus: {
        GLV: false,
        JUS: false,
        UBE: false
    },
    dataSummary: [],
    dataSummaryDelivery: [],
    dataSummaryComplaint: [],
    dataSummaryErrors: [],
    dataSummaryCancelled: [],
    dataEvolutionLastYearDelivery: [],
    dataEvolutionLastYearDeliveryGlobal: [],
    deliveryDataByRange: [],
    deliveryDataByRangeToRender: [],
    totalErrors: 0,
    totalOrders: 0,
    totalErrorsPercentage: 0,
    totalCancel: 0,
    totalCancelledPercentage: 0,
    maximumSaleYear: 0,
    maximumRatingYear: 0,
    maximumSaleWeekly: 0,
    maximumRatingWeekly: 0,
    chartData: {
        labels: [
          '3/9 Abril', '10/16 Abril', '17/23 Abril', '24/30 Abril', 
          '1/7 Mayo', '8/14 Mayo', '15/21 Mayo', '22/28 Mayo'
        ],
        datasets: [
          {
            type: 'line',
            label: this.$gettext('Average rating'),
            data: [3.2, 3.4, 3.5, 3.3, 3.6, 3.8, 4.0, 4.2],
            borderColor: '#4990e2', // Azul
            fill: false,
            yAxisID: 'y-axis-0'
          },
          {
            type: 'bar',
            label: this.$gettext('Number of orders'),
            data: [1500, 2000, 1800, 2200, 2100, 2500, 2700, 3000],
            backgroundColor: '#89c445', // Verde
            yAxisID: 'y-axis-1'
          }
        ],
    },
    chartDataWeekly:{

    },
    doughnutData: {
    },
    doughnutDataCancelled: {},
    lineData: {
    },
    lineCancel: {
    },
    img: {
        imgGlovo: require('@/assets/img/aggregators/glovo.svg'),
        imgUberEats: require('@/assets/img/aggregators/Uber Eats.png'),
        imgJustEat: require('@/assets/img/aggregators/Just Eat.png'),
        imgStar: require('@/assets/img/star.svg'),
        imgRatingBad: require('@/assets/img/glovo_rating_bad.svg'),
        imgRatingGlovoRegular: require('@/assets/img/rating_regular.png'),
    },      
    activeMenu:'MED',
    activeMenuWeekly: 'MED',
    };
  },
  created() {
    this.$store.dispatch('getAllSitesOpinions')
    if (this.$store.getters.getNode > 0) {
      this.getData()
    }
  },
  watch: {
    filterApply: function () {
      this.getData()
    }
  },
  methods:{
      transformDataErrors(){
        if(this.dataSummaryComplaint.complaints_by_reason){
          const colors             = ['#7e2d8e', '#8b572a', '#2abce9', '#fb9a99', '#fcae19', '#f36627', '#B695C0', '#FFF44F', '#82e0aa', '#34495e','#FF0033', '#00FF00']
          const labelsErrors       =  this.dataSummaryComplaint.complaints_by_reason.map((ele)=>ele.reason);
          const pentageDataErrors  =  this.dataSummaryComplaint.complaints_by_reason.map((ele)=>ele.percentage);
          const colorsErrors        = this.dataSummaryComplaint.complaints_by_reason.map((ele, index)=>colors[index]);

          this.doughnutData = {
            labels: labelsErrors,
            datasets:[{
              data: pentageDataErrors,
              backgroundColor: colorsErrors
            }]
          }
        }
      },
      transformDataCancelled(){
        if(this.dataSummaryComplaint.cancelled_by_reason){
          const colorsCancel       =  ['#7e2d8e', '#8b572a']
          const labelsCancel       =  ["Local", "Web"];
          const pentageDataCancel  =  [this.dataSummaryComplaint.cancelled_by_reason.local_percent, this.dataSummaryComplaint.cancelled_by_reason.web_percent];

          this.doughnutDataCancelled = {
            labels: labelsCancel,
            datasets:[{
              data: pentageDataCancel,
              backgroundColor: colorsCancel
            }]
          }
        }
      },
      transformDataLineError(){

        if(this.dataSummaryComplaint.errors){
          const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
          ];
          const labelsMonth = this.dataSummaryComplaint.errors.map((ele)=>{
            const monthIndex = parseInt(ele.month.split("-")[1]) - 1;
            return months[monthIndex];
          });

          const percentageMonth = this.dataSummaryComplaint.errors.map((ele)=>ele.errors_percent?.toFixed(2));

          this.lineData = {
            labels: labelsMonth,
            datasets: [
              {
                label: this.$gettext('% of error'),
                data: percentageMonth,
                borderColor: '#1E88E5',
                backgroundColor: 'rgba(30, 136, 229, 0.2)',
                fill: false,
                pointBackgroundColor: '#1E88E5',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#1E88E5'
              }
            ]
          }
        }
      },
      transformDataLineCancel(){

        if(this.dataSummaryComplaint.cancelled_data){
          const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
          ];
          const labelsMonth = this.dataSummaryComplaint.cancelled_data.map((ele)=>{
            const monthIndex = parseInt(ele.month.split("-")[1]) - 1;
            return months[monthIndex];
          });

          const percentageMonth = this.dataSummaryComplaint.cancelled_data.map((ele)=>ele.cancelled_percent?.toFixed(2));

          this.lineCancel = {
            labels: labelsMonth,
            datasets: [
              {
                label: this.$gettext('% of cancellations'),
                data: percentageMonth,
                borderColor: '#1E88E5',
                backgroundColor: 'rgba(30, 136, 229, 0.2)',
                fill: false,
                pointBackgroundColor: '#1E88E5',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#1E88E5'
              }
            ]
          }
        }
      },

      transformChartYear(type){


        if(this.dataEvolutionLastYearDelivery){

          try{
              const labelsMonth  = this.dataEvolutionLastYearDelivery.months.map((ele)=>ele);

              let mediaRatings = [];
              let mediaOrders  = [];

              if(type=="MED"){
                mediaRatings = this.dataEvolutionLastYearDelivery.ratings.map((ele)=>ele?.toFixed(2));
                mediaOrders  = this.dataEvolutionLastYearDelivery.n_orders.map((ele)=>ele);
              }else{
                mediaRatings = this.dataEvolutionLastYearDelivery.sites_delivery_data[type].ratings.map((ele)=>ele?.toFixed(2));

                mediaOrders  = this.dataEvolutionLastYearDelivery.sites_delivery_data[type].n_orders.map((ele)=>ele);
              }


              this.maximumRatingYear = mediaRatings.reduce((maxRating, ele) => {
                                          return Math.max(maxRating, ele);
                                        }, 0); 
              this.maximumSaleYear   = mediaOrders.reduce((maxSale, ele) => {
                                          return Math.max(maxSale, ele);
                                        }, 0); 

              
              this.maximumRatingYear = this.maximumRatingYear * 1.25; //Para que el grafico se vea mejor y no salga pegado al tope
              this.maximumSaleYear   = this.maximumSaleYear * 1.25;

              this.chartData = {
                labels: labelsMonth,
                datasets: [
                  {
                    type: 'line',
                    label: this.$gettext('Average rating'),
                    data: mediaRatings,
                    borderColor: '#4990e2', // Azul
                    fill: false,
                    yAxisID: 'y-axis-0'
                  },
                  {
                    type: 'bar',
                    label: this.$gettext('Number of orders'),
                    data: mediaOrders,
                    backgroundColor: '#89c445', // Verde
                    yAxisID: 'y-axis-1'
                  }
                ]
              }

          }catch(error){
            console.log(error);
          }
        }

      },
      transformChartWeekly(type){
        if(this.deliveryDataByRange){

          try{
              const labelsMonth  = this.deliveryDataByRange.weeks.map((ele)=>ele);

              let mediaRatings = [];
              let mediaOrders  = [];

              if(type=="MED"){
                mediaRatings = this.deliveryDataByRange.ratings.map((ele)=>ele?.toFixed(2));
                mediaOrders  = this.deliveryDataByRange.n_orders.map((ele)=>ele);
              }else{
                mediaRatings = this.deliveryDataByRange.sites_delivery_data[type].ratings.map((ele)=>ele?.toFixed(2));

                mediaOrders  = this.deliveryDataByRange.sites_delivery_data[type].n_orders.map((ele)=>ele);
              }
              this.maximumRatingWeekly = mediaRatings.reduce((maxRating, ele) => {
                                          return Math.max(maxRating, ele);
                                        }, 0); 
              this.maximumSaleWeekly   = mediaOrders.reduce((maxSale, ele) => {
                                          return Math.max(maxSale, ele);
                                        }, 0); 

              
              this.maximumRatingWeekly = this.maximumRatingWeekly * 1.25;
              this.maximumSaleWeekly   = this.maximumSaleWeekly * 1.25;

              this.chartDataWeekly = {
                labels: labelsMonth,
                datasets: [
                  {
                    type: 'line',
                    label: this.$gettext('Average rating'),
                    data: mediaRatings,
                    borderColor: '#4990e2', // Azul
                    fill: false,
                    yAxisID: 'y-axis-0'
                  },
                  {
                    type: 'bar',
                    label: this.$gettext('Number of orders'),
                    data: mediaOrders,
                    backgroundColor: '#89c445', // Verde
                    yAxisID: 'y-axis-1'
                  }
                ]
              }

          }catch(error){
            console.log(error);
          }
        }
      },
      setEvolutionOfAverage(type = 'MED', from) {
        
        if (from === "yearly") {
          this.activeMenu = type;
          this.transformChartYear(type);
          return;
        }

        if (from === "weekly") {
          this.activeMenuWeekly = type;
          this.transformChartWeekly(type);
          return;
        }

        // let filter;
        // let dataToRender;


        // if (type === 'MED') {
        //   filter       = this.evolutionLastYearDeliveryData
        //   dataToRender = this.deliveryDataByRange
        // }

        // if (type === 'JUS') {
        //   filter       = this.evolutionLastYearDeliveryData['sites_delivery_data']['JUS']
        //   dataToRender = this.deliveryDataByRange['sites_delivery_data']['JUS']
        // }

        // if (type === 'UBE') {
        //  filter = this.evolutionLastYearDeliveryData['sites_delivery_data']['UBE']
        //   dataToRender = this.deliveryDataByRange['sites_delivery_data']['UBE']
        // }

        

        // if (from === "yearly") {
        //   this.dataEvolutionLastYearDelivery = filter
        //   this.currentEvolutionOfAverage     = type
        //   return;
        // }

        // this.deliveryDataByRangeToRender     = dataToRender
        // this.weeklyCurrentEvolutionOfAverage = type

        
      },
      async getData() {
        this.$store.commit('LOADING', true);
        const res = await Promise.all([SrvNetWork.getEvolutionLastYearGlobal(), SrvNetWork.getGlobalDelivery(), SrvNetWork.getDeliveryByDateRange(), SrvNetWork.getEvolutionLastYear(), SrvNetWork.getGlobalSummaryComplaint()])

        if (res[0].status === 200) {
          //this.dataEvolutionLastYearDelivery = res[0].data
          this.evolutionLastYearDeliveryData = res[0].data
        }

        if (res[1].status === 200) {
          this.dataSummaryDelivery = res[1].data.data
          this.deliverySitesStatus = res[1].data.delivery_sites_status
          this.dateRanges = res[1].data.ranges
        }

        if (res[2].status === 200) {
          this.deliveryDataByRange = res[2].data
          this.deliveryDataByRangeToRender = res[2].data
        }

        if (res[3].status === 200) {
          this.dataEvolutionLastYearDelivery = res[3].data
          this.transformChartYear(this.activeMenu);
          this.transformChartWeekly(this.activeMenuWeekly);
        }

        if(res[4].status === 200){
          this.dataSummaryComplaint = res[4].data;
          this.totalErrors = this.dataSummaryComplaint?.complaints;
          this.totalErrorsPercentage = this.dataSummaryComplaint?.complaints_percentage_of_orders;
          this.totalOrders = this.dataSummaryComplaint?.total_orders;

          this.totalCancel = this.dataSummaryComplaint?.cancelled_by_reason.total;
          this.totalCancelledPercentage = this.dataSummaryComplaint.cancelled_by_reason?.total_percent;
          
          this.transformDataErrors();
          this.transformDataCancelled();
          this.transformDataLineError();
          this.transformDataLineCancel();
        }

        setTimeout(()=>{
          this.$store.commit('LOADING', false)
        }, 3000);

        
      }
  }
 
};
</script>

<style lang="scss" scoped>
#boxBarEvolutionOrders {

  .headTitleGrid {
    border-bottom: 3px solid #F3F3F3;
    padding-bottom: 3px;

    .nav {
      font-size: 0.750rem;

      button {
        padding-bottom: 2px;
        padding: 0 15px 2px 15px;
        position: relative;

        &.active {
          font-weight: bold;

          &:after {
            position: absolute;
            border-bottom: 3px solid #F41938;
            bottom: -6px;
            content: ' ';
            left: 0;
            width: 100%;
          }
        }
      }

      img {
        height: 16px;
      }
    }
  }

  div:last-child>span {
    font-size: 13px;
  }


  @media (max-width: 766px) {
    .headTitleGrid {
      .nav {
        button {
          padding-bottom: 5px;
          margin-bottom: 8px;

          &.active {
            position: static;
            margin-bottom: 12px;
            border-bottom: 3px solid #F41938;

            &:after {
              display: none;
            }
          }
        }
      }
    }
  }
}

#boxChartError {
  .chart-wrapper {
    display: flex;
    flex-direction: row;
    gap: 20px;

    .chart-item {
      flex: 1;
      min-width: 250px;
    }
  }

  @media (max-width: 768px) {
    .chart-wrapper {
      flex-direction: column;
    }
  }
}

#tableOrders{
td {
  padding: 5px !important;
}
th{
  text-align: center;
}
tr td:not(:first-child) {
  text-align: center;
}
.value-cell {
  display: flex;
  flex-direction: column;
  align-items: center; 
  min-width: 80px;
}

.top {
  display: flex;
  align-items: center;
  gap: 4px;
}

.main-value {
  font-weight: 500;
  width: 80px;
}

 .main-value-rating{
    display: flex;
    justify-content: center;
    width: 135px;
}

.bottom {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
  font-size: 12px;
  color: #777;
}

.sub-value {
  display: block;
  text-align: center;
  width: 80px;
}

.arrow {
  font-size: 14px;
}




}
:host {
  display: block;
  height: auto;
}



.text-small {
  font-size: 10px !important;
  line-height: 1;
}

.rating-num {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.sticky-table {
  min-width: 900px;
  width: 100%;
  border-collapse: collapse;
}

.sticky-table th,
.sticky-table td {
  padding: 12px;
  white-space: nowrap;
  border-bottom: 1px solid #ddd;
}

.sticky-col {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 2;
  width: 200px;
  min-width: 150px;
}

.left-col {
  min-width: 200px;
  max-width: 250px;
  width: 200px;
}




</style>
